import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import SproutlyPage from './pages/SproutlyPage';
import Service from './pages/Service';
import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import BetaInvitationPage from './pages/BetaInvitationPage';
import BetaInvitationSuccessPage from './pages/BetaInvitationSuccessPage';
import Contact from './pages/Contact';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import MemberAgreementPage from './pages/MemberAgreementPage';
import AutoRenewPage from './pages/AutoRenewPage';

// Import CSS
import './index.css';

function App() {
  return (
    <Router>
      <div className="page-wrapper">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/sproutly" element={<SproutlyPage />} />
            <Route path="/service" element={<Service />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/beta-invite" element={<BetaInvitationPage />} />
            <Route path="/beta-invite-success" element={<BetaInvitationSuccessPage />} />
            <Route path="/support" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/member-agreement" element={<MemberAgreementPage />} />
            <Route path="/membership-agreement" element={<MemberAgreementPage />} />
            <Route path="/auto-renew" element={<AutoRenewPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
